var cov_jit5foazk = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Button/Button.tsx",
      hash = "99749af033340a38dc417bb1e73700370b56a49a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Button/Button.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 21
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 29,
          column: 41
        },
        end: {
          line: 29,
          column: 51
        }
      },
      "2": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 34
        }
      },
      "3": {
        start: {
          line: 30,
          column: 19
        },
        end: {
          line: 30,
          column: 34
        }
      },
      "4": {
        start: {
          line: 31,
          column: 19
        },
        end: {
          line: 34,
          column: 6
        }
      },
      "5": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 91
        }
      },
      "6": {
        start: {
          line: 32,
          column: 80
        },
        end: {
          line: 32,
          column: 91
        }
      },
      "7": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 17
        }
      },
      "8": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 62
        }
      },
      "9": {
        start: {
          line: 35,
          column: 51
        },
        end: {
          line: 35,
          column: 61
        }
      },
      "10": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 53,
          column: 18
        }
      },
      "11": {
        start: {
          line: 54,
          column: 24
        },
        end: {
          line: 54,
          column: 73
        }
      },
      "12": {
        start: {
          line: 55,
          column: 17
        },
        end: {
          line: 55,
          column: 51
        }
      },
      "13": {
        start: {
          line: 56,
          column: 20
        },
        end: {
          line: 56,
          column: 46
        }
      },
      "14": {
        start: {
          line: 57,
          column: 16
        },
        end: {
          line: 57,
          column: 66
        }
      },
      "15": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 36
        }
      },
      "16": {
        start: {
          line: 58,
          column: 14
        },
        end: {
          line: 58,
          column: 36
        }
      },
      "17": {
        start: {
          line: 59,
          column: 22
        },
        end: {
          line: 68,
          column: 5
        }
      },
      "18": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 76,
          column: 5
        }
      },
      "19": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 75,
          column: 7
        }
      },
      "20": {
        start: {
          line: 78,
          column: 21
        },
        end: {
          line: 78,
          column: 39
        }
      },
      "21": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 89,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 16
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 31,
            column: 65
          },
          end: {
            line: 31,
            column: 66
          }
        },
        loc: {
          start: {
            line: 31,
            column: 73
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 31
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 35,
            column: 33
          },
          end: {
            line: 35,
            column: 34
          }
        },
        loc: {
          start: {
            line: 35,
            column: 51
          },
          end: {
            line: 35,
            column: 61
          }
        },
        line: 35
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 11
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 38
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 34
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 34
          }
        }],
        line: 30
      },
      "1": {
        loc: {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 32,
            column: 91
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 32,
            column: 91
          }
        }, {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 32,
            column: 91
          }
        }],
        line: 32
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 10
          },
          end: {
            line: 32,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 10
          },
          end: {
            line: 32,
            column: 17
          }
        }, {
          start: {
            line: 32,
            column: 21
          },
          end: {
            line: 32,
            column: 41
          }
        }, {
          start: {
            line: 32,
            column: 45
          },
          end: {
            line: 32,
            column: 78
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 35,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 35,
            column: 18
          }
        }, {
          start: {
            line: 35,
            column: 22
          },
          end: {
            line: 35,
            column: 24
          }
        }],
        line: 35
      },
      "4": {
        loc: {
          start: {
            line: 54,
            column: 24
          },
          end: {
            line: 54,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 24
          },
          end: {
            line: 54,
            column: 48
          }
        }, {
          start: {
            line: 54,
            column: 52
          },
          end: {
            line: 54,
            column: 64
          }
        }, {
          start: {
            line: 54,
            column: 68
          },
          end: {
            line: 54,
            column: 73
          }
        }],
        line: 54
      },
      "5": {
        loc: {
          start: {
            line: 55,
            column: 17
          },
          end: {
            line: 55,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 55,
            column: 31
          },
          end: {
            line: 55,
            column: 40
          }
        }, {
          start: {
            line: 55,
            column: 43
          },
          end: {
            line: 55,
            column: 51
          }
        }],
        line: 55
      },
      "6": {
        loc: {
          start: {
            line: 56,
            column: 20
          },
          end: {
            line: 56,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 20
          },
          end: {
            line: 56,
            column: 31
          }
        }, {
          start: {
            line: 56,
            column: 35
          },
          end: {
            line: 56,
            column: 46
          }
        }],
        line: 56
      },
      "7": {
        loc: {
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 57,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 57,
            column: 48
          },
          end: {
            line: 57,
            column: 57
          }
        }, {
          start: {
            line: 57,
            column: 60
          },
          end: {
            line: 57,
            column: 66
          }
        }],
        line: 57
      },
      "8": {
        loc: {
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 57,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 57,
            column: 23
          }
        }, {
          start: {
            line: 57,
            column: 27
          },
          end: {
            line: 57,
            column: 45
          }
        }],
        line: 57
      },
      "9": {
        loc: {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 36
          }
        }, {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 36
          }
        }],
        line: 58
      },
      "10": {
        loc: {
          start: {
            line: 60,
            column: 23
          },
          end: {
            line: 60,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 23
          },
          end: {
            line: 60,
            column: 42
          }
        }, {
          start: {
            line: 60,
            column: 46
          },
          end: {
            line: 60,
            column: 51
          }
        }],
        line: 60
      },
      "11": {
        loc: {
          start: {
            line: 60,
            column: 59
          },
          end: {
            line: 60,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 59
          },
          end: {
            line: 60,
            column: 66
          }
        }, {
          start: {
            line: 60,
            column: 70
          },
          end: {
            line: 60,
            column: 79
          }
        }],
        line: 60
      },
      "12": {
        loc: {
          start: {
            line: 63,
            column: 14
          },
          end: {
            line: 63,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 14
          },
          end: {
            line: 63,
            column: 18
          }
        }, {
          start: {
            line: 63,
            column: 22
          },
          end: {
            line: 63,
            column: 28
          }
        }],
        line: 63
      },
      "13": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }],
        line: 70
      },
      "14": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 12
          }
        }, {
          start: {
            line: 70,
            column: 16
          },
          end: {
            line: 70,
            column: 25
          }
        }],
        line: 70
      },
      "15": {
        loc: {
          start: {
            line: 81,
            column: 48
          },
          end: {
            line: 81,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 81,
            column: 48
          },
          end: {
            line: 81,
            column: 56
          }
        }, {
          start: {
            line: 81,
            column: 60
          },
          end: {
            line: 81,
            column: 67
          }
        }],
        line: 81
      },
      "16": {
        loc: {
          start: {
            line: 82,
            column: 9
          },
          end: {
            line: 86,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 9
          },
          end: {
            line: 82,
            column: 16
          }
        }, {
          start: {
            line: 83,
            column: 10
          },
          end: {
            line: 85,
            column: 17
          }
        }],
        line: 82
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Button/Button.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, isValidElement } from 'react';
import classnames from 'classnames';
import Spin from '../Spin';
import Group from './Group';
import Once from './Once';
import { wrapSpan } from '../utils/dom/element';
import { buttonClass } from './styles';
import { isRTL } from '../config';
import { getDirectionClass } from '../utils/classname';
var DefaultProps = (cov_jit5foazk.s[0]++, {
  size: 'default',
  htmlType: 'button',
  outline: false,
  type: 'default'
});

var Button =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Button, _PureComponent);

  var _super = _createSuper2(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "getChildren",
    value: function getChildren() {
      cov_jit5foazk.f[0]++;

      var _ref = (cov_jit5foazk.s[1]++, this.props),
          children = _ref.children,
          loading = _ref.loading,
          space = _ref.space;

      cov_jit5foazk.s[2]++;

      if (!children) {
        cov_jit5foazk.b[0][0]++;
        cov_jit5foazk.s[3]++;
        return children;
      } else {
        cov_jit5foazk.b[0][1]++;
      }

      var parsed = (cov_jit5foazk.s[4]++, React.Children.map(wrapSpan(children, space), function (item) {
        cov_jit5foazk.f[1]++;
        cov_jit5foazk.s[5]++;

        if ((cov_jit5foazk.b[2][0]++, loading) && (cov_jit5foazk.b[2][1]++,
        /*#__PURE__*/
        isValidElement(item)) && (cov_jit5foazk.b[2][2]++, item.type.isShineoutIcon)) {
          cov_jit5foazk.b[1][0]++;
          cov_jit5foazk.s[6]++;
          return null;
        } else {
          cov_jit5foazk.b[1][1]++;
        }

        cov_jit5foazk.s[7]++;
        return item;
      }));
      cov_jit5foazk.s[8]++;
      return ((cov_jit5foazk.b[3][0]++, parsed) || (cov_jit5foazk.b[3][1]++, [])).filter(function (v) {
        cov_jit5foazk.f[2]++;
        cov_jit5foazk.s[9]++;
        return v !== null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_jit5foazk.f[3]++;

      var _ref2 = (cov_jit5foazk.s[10]++, this.props),
          outlineProp = _ref2.outline,
          typeProp = _ref2.type,
          size = _ref2.size,
          href = _ref2.href,
          htmlType = _ref2.htmlType,
          loading = _ref2.loading,
          disabled = _ref2.disabled,
          onRef = _ref2.onRef,
          shape = _ref2.shape,
          text = _ref2.text,
          space = _ref2.space,
          target = _ref2.target,
          others = _objectWithoutProperties(_ref2, ["outline", "type", "size", "href", "htmlType", "loading", "disabled", "onRef", "shape", "text", "space", "target"]);

      var isSecondary = (cov_jit5foazk.s[11]++, (cov_jit5foazk.b[4][0]++, typeProp === 'secondary') && (cov_jit5foazk.b[4][1]++, !outlineProp) && (cov_jit5foazk.b[4][2]++, !text));
      var type = (cov_jit5foazk.s[12]++, isSecondary ? (cov_jit5foazk.b[5][0]++, 'primary') : (cov_jit5foazk.b[5][1]++, typeProp));
      var outline = (cov_jit5foazk.s[13]++, (cov_jit5foazk.b[6][0]++, outlineProp) || (cov_jit5foazk.b[6][1]++, isSecondary));
      var color = (cov_jit5foazk.s[14]++, (cov_jit5foazk.b[8][0]++, outline) || (cov_jit5foazk.b[8][1]++, type === 'default') ? (cov_jit5foazk.b[7][0]++, undefined) : (cov_jit5foazk.b[7][1]++, '#fff'));
      cov_jit5foazk.s[15]++;

      if (text) {
        cov_jit5foazk.b[9][0]++;
        cov_jit5foazk.s[16]++;
        color = 'currentColor';
      } else {
        cov_jit5foazk.b[9][1]++;
      }

      var className = (cov_jit5foazk.s[17]++, classnames(buttonClass('_', (cov_jit5foazk.b[10][0]++, shape !== 'default') && (cov_jit5foazk.b[10][1]++, shape), type, (cov_jit5foazk.b[11][0]++, outline) && (cov_jit5foazk.b[11][1]++, 'outline'), {
        large: size === 'large',
        small: size === 'small',
        text: (cov_jit5foazk.b[12][0]++, text) && (cov_jit5foazk.b[12][1]++, 'text'),
        rtl: isRTL(),
        disabled: disabled
      }), this.props.className));
      cov_jit5foazk.s[18]++;

      if ((cov_jit5foazk.b[14][0]++, href) && (cov_jit5foazk.b[14][1]++, !disabled)) {
        cov_jit5foazk.b[13][0]++;
        cov_jit5foazk.s[19]++;
        return (
          /*#__PURE__*/
          React.createElement("a", Object.assign({
            href: href
          }, others, {
            target: target,
            className: className,
            ref: onRef,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 72,
              columnNumber: 9
            }
          }), this.props.children)
        );
      } else {
        cov_jit5foazk.b[13][1]++;
      }

      var children = (cov_jit5foazk.s[20]++, this.getChildren());
      cov_jit5foazk.s[21]++;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/button-has-type
        React.createElement("button", Object.assign({}, others, {
          ref: onRef,
          disabled: (cov_jit5foazk.b[15][0]++, disabled) || (cov_jit5foazk.b[15][1]++, loading),
          type: htmlType,
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 81,
            columnNumber: 7
          }
        }), (cov_jit5foazk.b[16][0]++, loading) && (cov_jit5foazk.b[16][1]++,
        /*#__PURE__*/
        React.createElement("span", {
          className: buttonClass(getDirectionClass('spin')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 83,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement(Spin, {
          size: 12,
          name: "ring",
          color: color,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 84,
            columnNumber: 13
          }
        }))), children)
      );
    }
  }]);

  return Button;
}(PureComponent);

Button.displayName = 'ShineoutButton';
Button.Group = Group;
Button.Once = Once;
Button.defaultProps = DefaultProps;
export default Button;